import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleCallback, getToken } from '../../auth/authentikOidc';

const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * AuthentikCallback
 *
 * Mounted at /auth/callback. After PKCE token exchange:
 *   1. Try to claim a pending entitlement (paid via Stripe pre-signup).
 *      Idempotent: returns existing user if already claimed, or 403 if
 *      there's nothing to claim (handled silently. PrivateRoute renders
 *      the "Account niet gevonden" screen in that case).
 *   2. Navigate to `returnTo` (default /app).
 */
async function claimEntitlement() {
  try {
    const token = await getToken();
    if (!token) return;
    await fetch(`${API_URL}/api/users/claim-entitlement`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: '{}',
    });
    // Don't gate navigation on the result, even a 403 'no_entitlement' is
    // a normal outcome (user just logged in, no pending entitlement to claim).
  } catch (err) {
    // Network blip during claim is non-fatal; PrivateRoute will retry via useUser.
    console.warn('[auth] claim-entitlement failed (will retry via useUser):', err?.message);
  }
}

export default function AuthentikCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    handleCallback()
      .then(async ({ returnTo }) => {
        if (cancelled) return;
        await claimEntitlement();
        if (cancelled) return;
        navigate(returnTo, { replace: true });
      })
      .catch((err) => {
        if (cancelled) return;
        console.error('[auth] callback failed:', err);
        setError(err?.message || 'Login mislukt');
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div style={{ padding: 32, textAlign: 'center' }}>
        <h2>Inloggen mislukt</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/', { replace: true })}>
          Terug naar startpagina
        </button>
      </div>
    );
  }
  return <div style={{ padding: 32, textAlign: 'center' }}>Bezig met inloggen…</div>;
}
